import React, { useState, useEffect } from 'react'
import { Button, ButtonGroup, Grid, Row, Col } from 'react-bootstrap'
import { useDispatch } from 'react-redux'

import ExploringContainer from './Carrier/Exploring/ExploringContainer'
import Statistics from './Statistics/Statistics'
import Deliveries from './Carrier/Deliveries/DeliveriesContainer'
import { fetchCollection } from '../common/redux/collectionActions'

const activeTabColor = 'rgba(0, 110, 120, 0.5)'

const VendorView = ({ admin }) => {
  const [activeView, setActiveView] = useState('exploring')
  const dispatch = useDispatch()
  useEffect(() => {
    if (activeView === 'deliveries') {
      dispatch(fetchCollection('deliveries'))
    }
  }, [activeView])

  const isAhlsellVendor = admin.type === 'vendor' && admin.user?.name === 'Ahlsell'

  return (
    <Grid style={{ padding: 0, width: '90%' }}>
      <Row>
        <Col xs={12}>
          <ButtonGroup style={{ paddingLeft: 25, paddingBottom: 30, justifyContent: 'center', display: 'flex', width: '100%' }}>
            <Button style={{ flex: 1, background: activeView === 'exploring' ? activeTabColor : '' }} onClick={() => setActiveView('exploring')}>
              Karta
            </Button>
            <Button style={{ flex: 1, background: activeView === 'statistics' ? activeTabColor : '' }} onClick={() => setActiveView('statistics')}>
              Statistik
            </Button>
            {!isAhlsellVendor && (
              <Button style={{ flex: 1, background: activeView === 'deliveries' ? activeTabColor : '' }} onClick={() => setActiveView('deliveries')}>
                Leveranser
              </Button>
            )}
          </ButtonGroup>
        </Col>
      </Row>
      <Row>
        <Col xs={12}>{activeView === 'exploring' && <ExploringContainer />}</Col>
        <Col xs={12}>{activeView === 'statistics' && <Statistics />}</Col>
        <Col xs={12}>{activeView === 'deliveries' && <Deliveries />}</Col>
      </Row>
    </Grid>
  )
}

export default VendorView
